import { Link } from "react-router-dom";
import styled from "styled-components";

import Img from "./Img";
import github from "../assets/github.svg";
import google from "../assets/google.svg";
import linkedin from "../assets/linkedin.svg";
import twitter from "../assets/twitter.svg";
import youtube from "../assets/youtube.svg";

// ── Constants ────────────────────────────────────────────────────────────────

const SOCIAL_LINKS = [
  { src: linkedin, href: "/", alt: "LinkedIn" },
  { src: youtube, href: "/", alt: "YouTube" },
  {
    src: google,
    href: "https://scholar.google.com/citations?user=tUrAYVsAAAAJ&hl=en",
    alt: "Google Scholar",
    external: true,
  },
  {
    src: github,
    href: "https://github.com/pitt-miskov-zivanov-lab?view_as=public",
    alt: "GitHub",
    external: true,
  },
  { src: twitter, href: "/", alt: "Twitter", width: "18px" },
];

// ── Styled Components ────────────────────────────────────────────────────────

// DESKTOP: identical to original — no fixed height here, height is
// controlled by FooterWrapper in Layout.jsx (60px). On mobile we let
// it grow naturally so wrapped content isn't clipped.
const FooterWrapper = styled.footer`
  background-color: #0a2260;
  padding: 20px 16px;
  color: white;
  text-align: center;
  height: 100%;           /* fill whatever Layout.jsx gives us */
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  padding: 0 24px;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 0 8px;
  }
`;

const FooterText = styled.div`
  font-size: 14px;
  color: #ccc;

  a {
    color: #ccc;
    font-size: 14px;
    transition: opacity 0.3s;
  }

  @media (max-width: 600px) {
    font-size: 12px;

    a {
      font-size: 12px;
    }
  }
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;

  a {
    color: white;
    font-size: 14px;
    transition: opacity 0.3s;
    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 600px) {
    gap: 14px;
  }
`;

const WhiteLink = styled(Link)`
  color: #fff;
  text-decoration: none;
  margin: 0 4px;
`;

// ── Component ────────────────────────────────────────────────────────────────

export default function Footer({
  isHomepage = false,
  isToolPage = false,
  rddLink = "/",
  gLink = "/",
}) {
  return (
    <FooterWrapper>
      <FooterContent>
        <FooterText>
          © 2026{" "}
          <Link
            to="https://www.nmzlab.pitt.edu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Miskov-Zivanov Lab (MeLoDy lab)
          </Link>
        </FooterText>

        <FooterLinks>
          {isToolPage && (
            <>
              <Link to={rddLink} target="_blank" rel="noopener noreferrer">
                ReadTheDocs
              </Link>
              <Link to={gLink} target="_blank" rel="noopener noreferrer">
                GitHub
              </Link>
            </>
          )}

          {isHomepage &&
            SOCIAL_LINKS.map(({ src, href, alt, external, width }) => (
              <Link
                key={alt}
                to={href}
                rel="noopener noreferrer"
                {...(external && { target: "_blank" })}
              >
                <Img src={src} alt={alt} width={width} />
              </Link>
            ))}
        </FooterLinks>
      </FooterContent>
    </FooterWrapper>
  );
}